import axios from "axios";
import {
  SET_LOADER,
  SET_LOADER_SECONDARY,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  SUPERADMIN_GET_ALL_RESTAURANT_NOMINATIONS,
  SUPERADMIN_GET_NOMINATION_ACTIVITY,
  SUPERADMIN_VIEW_NOMINATION_RESTAURANT,
  SUPERADMIN_CHANGE_NOMINATION_STATUS,
  SUPERADMIN_VIEW_ALL_REVIEWS,
  SUPERADMIN_CHANGE_REVIEW_STATUS,
  SUPERADMIN_GET_ALL_SUGGESTIONS,
  SUPERADMIN_CHANGE_SUGGESTION_STATUS,
  SUPERADMIN_ADD_SUGGESTION,
  SUPERADMIN_ADD_ISSUES,
  GET_ALL_EVENTS_ADMIN,
  GET_ONLINE_EVENT,
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../errorActions";
import { serverApi } from "../../../config/Keys";

export const getAllRestaurantNominations =
  (
    token,
    // nextPageNo,
    // page,
    // search,
    // sort,
    startDate,
    endDate,
    // city,
    onSuccessNominations,
    onErrorNominations
  ) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_restaurant_nominations = await axios.get(
        `${serverApi}/admin/nominations?startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_restaurant_nominations.status === 200) {
        onSuccessNominations();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_GET_ALL_RESTAURANT_NOMINATIONS,
          payload: get_restaurant_nominations,
        });
      }
    } catch (err) {
      if (err.response != null && err.response !== undefined) {
        onErrorNominations();
      }
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const onChangeNominationStatus =
  (token, formData, id, onSuccessNominations, onErrorNominations) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let change_nomination_status = await axios.patch(
        `${serverApi}/admin/nominations/${id}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (change_nomination_status.status === 200) {
        onSuccessNominations();
        formData.id = id;
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_CHANGE_NOMINATION_STATUS,
          payload: formData,
        });
      }
    } catch (err) {
      onErrorNominations();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const getNominationsActivity =
  (
    token,
    page,
    search,
    sort,
    startDate,
    endDate,
    city,
    onSuccessNominations,
    onErrorNominations
  ) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_nominations_activity = await axios.get(
        `${serverApi}/admin/nominations?activityDetails=true&limit=10&page=${page}&search=${search}&sort=${sort}&startDate=${startDate}&endDate=${endDate}&city=${city}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_nominations_activity.status === 200) {
        onSuccessNominations();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_GET_NOMINATION_ACTIVITY,
          payload: get_nominations_activity,
        });
      }
    } catch (err) {
      onErrorNominations();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const viewNominationsByRestaurantId =
  (token, onSuccessNominations, onErrorNominations) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let view_nomination_restaurant = await axios.get(
        `${serverApi}/admin/restaurant?status=ACTIVE`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (view_nomination_restaurant.status === 200) {
        onSuccessNominations();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_VIEW_NOMINATION_RESTAURANT,
          payload: view_nomination_restaurant.data,
        });
      }
    } catch (err) {
      onErrorNominations();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const viewAllReviews =
  (
    token,
    type,
    filterType,
    enumType,
    onSuccessReviews,
    onErrorReviews,
    startDate,
    endDate
  ) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_restaurant_reviews = await axios.get(
        `${serverApi}/admin/review-rating?reviewType=${type}&filterType=${filterType}&type=${enumType}&startDate=${startDate}&endDate=${endDate}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_restaurant_reviews.status === 200) {
        onSuccessReviews();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_VIEW_ALL_REVIEWS,
          payload: get_restaurant_reviews.data,
        });
      } else {
        onErrorReviews();
      }
    } catch (err) {
      onErrorReviews();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const changeReviewStatus =
  (
    token,
    reviewId,
    formData,
    filterType,
    onSuccessChangeStatus,
    onErrorChangeStatus
  ) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let change_review_status = await axios.patch(
        `${serverApi}/admin/review-rating/${reviewId}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (change_review_status.status === 200) {
        const prepareStatus = {};
        prepareStatus.id = reviewId;
        prepareStatus.status = formData.status;
        prepareStatus.filterType = filterType;
        onSuccessChangeStatus();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_CHANGE_REVIEW_STATUS,
          payload: prepareStatus,
        });
        if (formData.status) {
          Alert.success(`<h4> Review unhide  sucessfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        } else {
          Alert.success(`<h4> Review hide sucessfully</h4>`, {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          });
        }
      } else {
        onErrorChangeStatus();
      }
    } catch (err) {
      onErrorChangeStatus();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const getallSuggestions =
  (token, selectedTab, skip, onSuccessSuggestions, onErrorSuggestions) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      var get_all_suggestions;
      if (selectedTab !== 3) {
        // &$skip=${skip}&$limit=10
        get_all_suggestions = await axios.get(
          `${serverApi}/admin/suggestions?status=${selectedTab}`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      } else {
        get_all_suggestions = await axios.get(
          `${serverApi}/admin/suggestions?$skip=${skip}&$limit=10`,
          {
            headers: {
              Authorization: token,
            },
          }
        );
      }

      if (get_all_suggestions.status === 200) {
        onSuccessSuggestions();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_GET_ALL_SUGGESTIONS,
          payload: get_all_suggestions.data,
        });
      } else {
        onErrorSuggestions();
      }
    } catch (err) {
      onErrorSuggestions();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const changeSuggestionStatus =
  (token, formData, suggestionId, onSuccessChangeStatus, onErrorChangeStatus) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let update_suggestion_status = await axios.patch(
        `${serverApi}/suggestions/${suggestionId}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (update_suggestion_status.status === 200) {
        formData.id = suggestionId;

        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_CHANGE_SUGGESTION_STATUS,
          payload: formData,
        });
        Alert.success(`<h4> Status updated sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccessChangeStatus();
      } else {
        onErrorChangeStatus();
      }
    } catch (err) {
      onErrorChangeStatus();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const addNewSuggestionAdmin =
  (token, formData, onSuccessAddSuggestion, onErrorAddSuggestion) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });

    try {
      let add_new_suggestion = await axios.post(
        `${serverApi}/suggestions`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (add_new_suggestion.status === 201) {
        onSuccessAddSuggestion();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: SUPERADMIN_ADD_SUGGESTION,
        });
        Alert.success(`<h4> Suggestion added sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      } else {
        onErrorAddSuggestion();
      }
    } catch (err) {
      onErrorAddSuggestion();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const addNewIssuesAdmin =
  (token, formData, onSuccessAddIssues, onErrorAddIssues) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_new_issues = await axios.post(
        `${serverApi}/admin/issues`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (add_new_issues.status === 201) {
        dispatch({
          type: SUPERADMIN_ADD_ISSUES,
        });
        Alert.success(`<h4>Issues added sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccessAddIssues();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorAddIssues();
    }
  };

export const addIssuesSuggestionAdmin =
  (token, formData, onSuccessAddIssues, onErrorAddIssues) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_new_issues = await axios.post(
        `${serverApi}/admin/issues-suggestions`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (add_new_issues.status === 201) {
        dispatch({
          type: SUPERADMIN_ADD_ISSUES,
        });
        Alert.success(`<h4>Added sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccessAddIssues();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onErrorAddIssues();
    }
  };

export const get_all_events = (token, onSuccess) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_all_events = await axios.get(`${serverApi}/admin/events`, {
      headers: {
        Authorization: token,
      },
    });
    if (get_all_events.status === 200) {
      onSuccess();
      dispatch({ type: CLEAR_LOADER });
      dispatch({
        type: GET_ALL_EVENTS_ADMIN,
        payload: get_all_events.data,
      });
    }
  } catch (err) {
    //onErrorReviews();
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

export const update_admin_event =
  (token, formData, eventId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_admin_event = await axios.patch(
        `${serverApi}/admin/events/${eventId}`,
        formData,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (update_admin_event.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      //onErrorReviews();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const delete_event_admin =
  (token, eventId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let delete_event_admin = await axios.delete(
        `${serverApi}/admin/events/${eventId}`,

        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (delete_event_admin.status === 200) {
        onSuccess();
        Alert.success(`<h4> Event Deleted  Sucessfully</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch({ type: CLEAR_LOADER });
      }
      dispatch({ type: CLEAR_LOADER });
    } catch (err) {
      //onErrorReviews();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const get_online_event =
  (token, eventId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_online_event = await axios.get(
        `${serverApi}/admin/event-handler?event_id=${eventId}`,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (get_online_event.status === 200) {
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
        dispatch({
          type: GET_ONLINE_EVENT,
          payload: get_online_event.data,
        });
      }
    } catch (err) {
      //onErrorReviews();
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
